import { TOptionsBase } from "i18next";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES_TYPE } from "../i18n";

const LOCALSTORAGE_LANGUAGE_CODE_KEY = "languageCode";

export const saveLanguageCode = (code: SUPPORTED_LANGUAGES_TYPE): void => {
  localStorage.setItem(LOCALSTORAGE_LANGUAGE_CODE_KEY, code);
};

export const getLanguageCode = (): SUPPORTED_LANGUAGES_TYPE | undefined => {
  return (
    (localStorage.getItem(
      LOCALSTORAGE_LANGUAGE_CODE_KEY,
    ) as SUPPORTED_LANGUAGES_TYPE) ?? undefined
  );
};

export const useCustomTranslation = () => {
  const { t } = useTranslation();

  const tCommon = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "customerportal-common", ...options });

  const tInvite = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "customerportal-invite", ...options });

  const tInput = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "inputs", ...options });

  const tError = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "errors", ...options });

  const tOrder = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "order", ...options });

  const tIntervention = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "intervention", ...options });

  const tServiceObject = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "serviceObject", ...options });

  const tCompany = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "company", ...options });

  const tRequest = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "request", ...options });

  const tCustomForm = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "customForm", ...options });

  const tReport = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "reports", ...options });

  const tCustomer = (
    key: string,
    options?: TOptionsBase & Record<string, number | string | undefined>,
  ) => t(key, { ns: "customer", ...options });

  // plain t is used for global common namespace
  return {
    t,
    tInvite,
    tInput,
    tError,
    tCommon,
    tOrder,
    tServiceObject,
    tIntervention,
    tRequest,
    tCompany,
    tCustomForm,
    tReport,
    tCustomer,
  };
};
